
//自动加载监控逻辑 
let loadUam = (self) => {
  try {
      let uam_win = window;
      let uam_config = {};
      let uam_xy_paq = self.uam_xy_paq;
      console.log("uam_xy_paq:" + uam_xy_paq);
      let uam_flagflag = false;
      let uam_pageurl;
      let startDate = new Date();
      let endDate;
      let pageId;
      let sessionobj ={};
      //取出uam_xy_paq变量中key对应的value值
      let findPaq = function (key) {
          try {
              for (var i = uam_xy_paq.length-1; i >=0; i--) {
                  var uam_param = uam_xy_paq[i];
                  if(uam_param[0] == key) {
                      return uam_param[1];
                  }
              }
          } catch (e) {
            console.log(e);
          }
      };
      var sessionId = findPaq("sessionId");
      var virtualOrderId = findPaq("virtualOrderId");//虚单ID
      var systemCode = findPaq('systemCode');
      var moduleCode = findPaq('moduleCode');
      var menuId = findPaq('menuId');
      var uam_setLoginName = findPaq('setLoginName');
      var serverUrl = findPaq('server_url');
      var areaCode = findPaq("areaCode");
      var staffId = findPaq("staffId");
      var custOrderNbr = findPaq("custOrderNbr");
      var channelNbr = findPaq("channelNbr");
      var custId = findPaq("custId");
      var custCertNbr = findPaq("custCertNbr");
      var custCertType = findPaq("custCertType");
      var orderFlowCode;
      var operCode;
      var stepCode;

      setTimeout(function () {
          if (uam_flagflag) return;

          uam_xy_run();
          if (uam_xy_paq) {
              //获得监控的用户
              uam_config.main(systemCode, uam_setLoginName, serverUrl);
              uam_flagflag = true;
          }
      }, 2000);


      uam_win.document.onreadystatechange = function () {
          if (uam_flagflag) return;

          uam_xy_run();
          if (uam_win.document.readyState == "complete") {
              pageendDate = new Date();

              if (uam_xy_paq) {
                  uam_config.main(systemCode, uam_setLoginName, serverUrl);
                  uam_flagflag = true;
              }
          }

      };


      function uam_xy_run() {
          //主方法入口,事件监听
          uam_config.main = function (systemCode, uam_setLoginName, serverUrl) {

              try {
                
                  if (systemCode == "") {
                    return;
                  }

                  console.log("uam_config.main=============");

                  //生成一个模似客户

                  //得到页面的url
                  uam_pageurl = uam_config.getUrl();
                  var referurl = uam_config.getUrlReferrer();

                  //页面加载时间
                  uam_config.loadpageTimes = uam_config.getPerformanceTiming();

                  //发送打开页面所需发送的属性
                  uam_config.dealStart();

                  var inputList = window.document.getElementsByTagName('input');
                  if (uam_win.addEventListener)//IE9,IE10,IE11,chrome,firefox,qq,else
                  {
                      //监听页面离开unload的事件
                      window.addEventListener('unload', function (e) {
                          endDate = new Date();
                          e.restTime = endDate - startDate;
                          e.listnerEvent = "unload";
                          uam_config.dealEvent(e);
                      }, true);

                      //监听click的事件
                      window.addEventListener('click', function (e) {
                          e.listnerEvent = "click";
                          uam_config.dealEvent(e);
                      }, true);

                      //监听双击dbclick事件
                      window.addEventListener('dblclick', function (e) {
                          e.listnerEvent = "dblclick";
                          uam_config.dealEvent(e);
                      }, true);

                      //监听按键事件
                      window.addEventListener('keydown', function (e) {
                          e.listnerEvent = "keydown";
                          uam_config.dealEvent(e);
                      }, true);
                      //监听input的事件
                      for (var i = 0; i < inputList.length; i++) {
                          inputList[i].addEventListener('focus', function (e) {
                              e.listnerEvent = "focus";
                              uam_config.dealEvent(e);
                          }, true);
                      }
                  } else //IE8,IE7,IE6,IE5
                  {
                      //监听页面离开load的事件
                      window.document.attachEvent('onunload', function (e) {
                          endDate = new Date();
                          e.restTime = endDate - startDate;
                          e.listnerEvent = "onunload";
                          uam_config.dealEvent(e);
                      }, true);

                      //监听click的事件
                      window.document.attachEvent('onclick', function (e) {
                          e.listnerEvent = "onclick";
                          uam_config.dealEvent(e);
                      }, true);

                      //监听双击dbclick事件
                      window.document.attachEvent('ondblclick', function (e) {
                          e.listnerEvent = "ondblclick";
                          uam_config.dealEvent(e);
                      }, true);

                      //监听按键事件
                      window.document.attachEvent('onkeydown', function (e) {
                          e.listnerEvent = "onkeydown";
                          uam_config.dealEvent(e);
                      }, true);

                      //监听input的事件
                      for (var i = 0; i < inputList.length; i++) {

                          inputList[i].attachEvent('onfocus', function (e) {
                              e.listnerEvent = "onfocus";
                              uam_config.dealEvent(e);
                          }, true);
                      }
                  }
              } catch (e) {
              }

          };

          //页面操作事件处理
          uam_config.dealEvent = function (e) {
              try {
                  console.log("uam_config.dealEvent=============");
                  var uam_e = e || window.event;
                  var uam_obj = uam_e.srcElement ? uam_e.srcElement : uam_e.target;
                  orderFlowCode = uam_config.getNull(uam_obj.dataset.orderflowcode);
                  operCode = uam_config.getNull(uam_obj.dataset.opercode);
                  stepCode = uam_config.getNull(uam_obj.dataset.stepcode);
                  console.log("======operCode============" + operCode);
                  if (operCode === 'none') {
                    return;
                  }
                  //屏幕分辨率uam_clientWidth、uam_clientHeight
                  var uam_clientWidth = uam_win.document.body.clientWidth;
                  var uam_clientHeight = uam_win.document.body.clientHeight;
                  //元素坐标uam_x、uam_y
                  var uam_x = uam_e.clientX + uam_win.document.body.scrollLeft + uam_win.document.documentElement.scrollLeft;
                  var uam_y = uam_e.clientY + uam_win.document.body.scrollTop + uam_win.document.documentElement.scrollTop;

                  sessionId = findPaq("sessionId");
                  virtualOrderId = findPaq("virtualOrderId");//虚单ID
                  //获取cookies中的sessionId;
                  var cookie_seesionId;
                  if (sessionId != "" && sessionId != null) {
                      cookie_seesionId = uam_config.getCookie("sessionId");
                      if (sessionId != cookie_seesionId) {
                          uam_config.updateCookie("sessionId", sessionId);
                      }
                  } else {
                      sessionId = uam_config.getCookie("sessionId");
                  }
                  //获取cookies 并比较虚单id是否一样
                  var cookie_virtualOrderId;
                  if (virtualOrderId != "" && virtualOrderId != null) {
                      cookie_virtualOrderId = uam_config.getCookie("virtualOrderId");
                      if (virtualOrderId != cookie_virtualOrderId) {
                          uam_config.updateCookie("virtualOrderId", virtualOrderId);
                      }

                  } else {
                      virtualOrderId = uam_config.getCookie("virtualOrderId");
                  }


                  var keyCode = uam_e.keyCode;
                  var restTime = uam_e.restTime;
                  var id = uam_config.getNull(uam_obj.id);
                  var tagname = uam_config.getNull(uam_obj.tagName);
                  var type = uam_config.getNull(uam_obj.type);
                  var value = removeR(uam_config.getNull(uam_obj.value));
                  var name = uam_config.getNull(uam_obj.name);
                  var className = uam_config.getNull(uam_obj.className);
                  var innerText = removeR(uam_config.getNull(uam_obj.innerText).substring(0, 50));
                  var listnerEvent = uam_e.type;
                  var uam_browser = window.navigator.userAgent;
                  var evtTime = uam_config.getEventTime();
                  var eventType;
                  console.log("======1============");
                  if (listnerEvent == "focus" || listnerEvent == "onfocus") {
                      eventType = "eleFocus";
                  } else if (listnerEvent == "load" || listnerEvent == "onload") {
                      eventType = "pageLoad";
                  } else if (listnerEvent == "unload" || listnerEvent == "onunload") {
                      eventType = "pageUnload";
                  } else if (listnerEvent == "click" || listnerEvent == "onclick") {
                      eventType = "eleClick";
                  } else if (listnerEvent == "dblclick" || listnerEvent == "ondblclick") {
                      eventType = "eleDbclick";
                  } else if (listnerEvent == "keydown" || listnerEvent == "onkeydown") {
                      eventType = "pageKeypress";
                  }
                  uam_config.elementAttrs = {
                      'id': id,
                      'tagname': tagname,
                      'type': type,
                      'value': value,
                      'name': name,
                      'className': className,
                      'innerText': innerText
                  }
                  console.log("======2============");
                  //每次必传
                  uam_config.uam_sendBaseConfig = {
                      'areaCode': areaCode,
                      'systemCode': systemCode,
                      'moduleCode': moduleCode,
                      'menuId': menuId,
                      'staffId': staffId,
                      'custOrderNbr': custOrderNbr,
                      'channelNbr': channelNbr,
                      'custId': custId,
                      'custCertNbr': custCertNbr,
                      'custCertType': custCertType,
                      'orderFlowCode': orderFlowCode,
                      'operCode': operCode,
                      'stepCode': stepCode,
                      'referURL': uam_config.getUrlReferrer(),
                      'pageId': pageId,
                      'browserType': uam_config.getBrowserInfo()
                  };
                  console.log("======3============");
                  //发送点击事件信息到服务端
                  uam_config.send({
                      'evtTime': evtTime,//事件发生时前端时间
                      'pageLoadTime': uam_config.loadpageTimes[0].loadpage,//页面请求时间
                      'eventType': eventType,
                      'sessionId': sessionId,
                      'virtualOrderId': virtualOrderId,
                      'userAgent': uam_browser,
                      'screenWidth': uam_clientWidth,
                      'screenHeight': uam_clientHeight,
                      'pageTitle': uam_win.document.title,
                      'requestURL': uam_pageurl,
                      'clientX': uam_x,
                      'clientY': uam_y,
                      'keyCode': keyCode,
                      'restTime': restTime
                  }, serverUrl);
              } catch (e) {
              }


          }

          //页面加载事件处理
          uam_config.dealStart = function () {
              try {
                  console.log("uam_config.dealStart=============");
                  pageId = uam_config.getuuid();

                  //屏幕分辨率uam_clientWidth、uam_clientHeight
                  var uam_clientWidth = uam_win.document.body.clientWidth;
                  var uam_clientHeight = uam_win.document.body.clientHeight;

                  //获取cookies中的sessionId;
                  var cookie_seesionId;
                  if (sessionId != "" && sessionId != null) {
                      cookie_seesionId = uam_config.getCookie("sessionId");
                      if (sessionId != cookie_seesionId) {
                          uam_config.updateCookie("sessionId", sessionId);
                      }
                  } else {
                      sessionId = uam_config.getCookie("sessionId");
                  }

                  //获取cookies 并比较虚单id是否一样
                  console.log("uam_config.dealStart=============1");
                  var cookie_virtualOrderId;
                  if (virtualOrderId != "" && virtualOrderId != null) {
                      cookie_virtualOrderId = uam_config.getCookie("virtualOrderId");
                      if (virtualOrderId != cookie_virtualOrderId) {
                          uam_config.updateCookie("virtualOrderId", virtualOrderId);
                      }
                  } else {
                      virtualOrderId = uam_config.getCookie("virtualOrderId");
                  }

                  console.log("uam_config.dealStart=============2");

                  var uam_browser = window.navigator.userAgent;
                  var eventType = "pageLoad";
                  var evtTime = uam_config.getEventTime();
                  console.log("uam_config.dealStart=============2.1");
                  //每次必传
                  uam_config.uam_sendBaseConfig = {
                      'areaCode': areaCode,
                      'systemCode': systemCode,
                      'moduleCode': moduleCode,
                      'menuId': menuId,
                      'staffId': staffId,
                      'custOrderNbr': custOrderNbr,
                      'channelNbr': channelNbr,
                      'custId': custId,
                      'custCertNbr': custCertNbr,
                      'custCertType': custCertType,
                      'orderFlowCode': ' ',
                      'operCode': ' ',
                      'stepCode': ' ',
                      'referURL': uam_config.getUrlReferrer(),
                      'pageId': pageId,
                      'browserType': uam_config.getBrowserInfo()
                  };
                  console.log("uam_config.dealStart=============3");
                  //发送加载事件信息到服务端
                  uam_config.send({
                      'evtTime': evtTime,//事件发生时前端时间
                      'pageLoadTime': uam_config.loadpageTimes[0].loadpage,//页面请求时间
                      'dnsTime': uam_config.loadpageTimes[0].lookupDomain,//域名解析时间
                      'conTime': uam_config.loadpageTimes[0].connect,//建立连接花费时间
                      'reqTime': uam_config.loadpageTimes[0].request,//请求数据花费时间
                      'resTime': uam_config.loadpageTimes[0].receive,//接收数据花费时间
                      'eventType': eventType,
                      'sessionId': sessionId,
                      'virtualOrderId': virtualOrderId,
                      'userAgent': uam_browser,
                      'screenWidth': uam_clientWidth,
                      'screenHeight': uam_clientHeight,
                      'pageTitle': uam_win.document.title,
                      'requestURL': uam_pageurl
                  }, serverUrl);
              } catch (e) {
              }
          };
          uam_config.getNull = function (uam_obj) {
              return uam_obj || 'none';
          };
          //去除换行符
          function removeR(str) {
              try {
                  return str.replace(/[\r\n]/g, ' ');
              } catch (e) {
              }
          }
          //获取url
          uam_config.getUrl = function () {
              try {
                  return uam_win.location.href;
              } catch (e) {
              }
          };
          uam_config.getUrlReferrer = function () {
              try {
                  return uam_win.document.referrer;
              } catch (error) {
              }
          };

          //请求到服务端
          uam_config.send = function (message, serverUrl) {
              try {
                  console.log("uam_config.send=============");
                  var loginName = uam_config.uam_sendBaseConfig.uam_username;
                  if (typeof (loginName) == "undefined") {
                      uam_setLoginName = findPaq('setLoginName');
                      uam_config.uam_sendBaseConfig.uam_username = uam_setLoginName;
                  }
                  //字符编码转换
                  var uam_sendBaseConfig = uam_config.encodeCharset(uam_config.uam_sendBaseConfig);
                  var uam_message = uam_config.encodeCharset(message);
                  var uam_elementAttrs = uam_config.encodeCharset(uam_config.elementAttrs);

                  //拼接字符串为URl格式
                  var baseparams = uam_config.uam_buildUrlParams(uam_sendBaseConfig);
                  var uam_messageparams = uam_config.uam_buildUrlParams(uam_message);
                  var elementAttrs = uam_config.uam_buildUrlParams(uam_elementAttrs);

                  //构成URL
                  var uam_url = serverUrl + "?" + baseparams + elementAttrs + uam_messageparams + "date=" + new Date().getTime();
                  var uam_logImage = new Image();
                  uam_logImage.onload = function () {
                      uam_logImage = null;
                  };
                  uam_logImage.src = uam_url;
              } catch (e) {
              }
          };

          //获取cookie值
          uam_config.getCookie = function (name) {
              try {
                  var strcookie = document.cookie;
                  var arrcookie = strcookie.split(";");
                  for (var i = 0; i < arrcookie.length; i++) {
                      var arr = arrcookie[i].split("=");
                      if (arr[0].replace(/\s*/g, "")==name.replace(/\s*/g, "")) {
                          return arr[1];
                      }
                  }
                  return "";
              } catch (error) {
                  return "";
              }
          }
          //更改cookie值
          uam_config.updateCookie = function (name, value) {
              try {
                  document.cookie = name + "=" + value + "; path=/";
              } catch (error) {
              }
          }

          //拼接字符串为URl格式
          uam_config.uam_buildUrlParams = function (uam_config) {
              var uam_param = '';
              for (var p in uam_config) {
                  try {
                      uam_param += p + '=' + uam_config[p].replace(/#/g, "");
                      uam_param += '&';
                  } catch (e) {
                      uam_param += p + '=' + uam_config[p];
                      uam_param += '&';
                  }
              }
              return uam_param;
          };

          //编码转换
          uam_config.encodeCharset = function (obj) {
              for (var p in obj) {
                  try {
                      obj[p] = encodeURIComponent(encodeURIComponent(obj[p]));
                  } catch (e) {
                  }
              }
              return obj;
          }

          uam_config.guid = function () {
              return 'xxxxxxxxxxxx4xxxyxxxxxxxxxx'.replace(/[xy]/g, function (uam_c) {
                  try {
                      var uam_r = Math.random() * 16 | 0;
                      var uam_v = uam_c == 'x' ? uam_r : (uam_r & 0x3 | 0x8);
                      return uam_v.toString(16);
                  } catch (e) {
                  }
              });
          };

          //获取随机数
          uam_config.getuuid = function () {
              try {
                  return (uam_config.getUUnumber() + uam_config.getUUnumber() + "-" + uam_config.getUUnumber() + "-" + uam_config.getUUnumber() +
                      "-" + uam_config.getUUnumber() + "-" + uam_config.getUUnumber() + uam_config.getUUnumber() + uam_config.getUUnumber());
              } catch (e) {
              }
          };

          uam_config.getUUnumber = function () {
              try {
                  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
              } catch (e) {
              }
          };

          //获取事件开始时间
          uam_config.getEventTime = function () {
              try {
                  var uam_startDate = new Date();
                  var month = uam_startDate.getMonth() + 1;
                  if (month < 10) {
                      month = 0 + '' + month
                  }
                  var day = uam_startDate.getDate()
                  if (day < 10) {
                      day = 0 + '' + day
                  }
                  var evtTime = uam_startDate.getFullYear() + '' + month + '' + day + '' + uam_startDate.getHours() + ''
                      + uam_startDate.getMinutes() + '' + uam_startDate.getSeconds() + '' + uam_startDate.getMilliseconds();
                  return evtTime;
              } catch (e) {
              }
          }

          //获取当前浏览器类型和版本号
          uam_config.getBrowserInfo = function () {
                var agent = navigator.userAgent.toLowerCase() ;
                var regStr_ie = /msie [\d.]+;/gi ;
                var regStr_ff = /firefox\/[\d.]+/gi
                var regStr_chrome = /chrome\/[\d.]+/gi ;
                var regStr_saf = /safari\/[\d.]+/gi ;
                //IE11以下
                if(agent.indexOf("msie") > 0)
                {
                    return agent.match(regStr_ie) ;
                }
                //IE11版本中不包括MSIE字段
                if(agent.indexOf("trident") > 0&&agent.indexOf("rv") > 0){
                    return "IE " + agent.match(/rv:(\d+\.\d+)/) [1];
                }
                //firefox
                if(agent.indexOf("firefox") > 0)
                {
                    return agent.match(regStr_ff) ;
                }
                //Chrome
                if(agent.indexOf("chrome") > 0)
                {
                    return agent.match(regStr_chrome) ;
                }
                //Safari
                if(agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0)
                {
                    return agent.match(regStr_saf) ;
                }
          }

          //计算加载时间
          uam_config.getPerformanceTiming = function () {
              var performance = window.performance;
              var loadpageTimes = [];
              if (!performance) {//浏览器不支持
                  loadpageTimes.push({
                      'lookupDomain': 0,
                      'connect': 0,
                      'request': 0,
                      'receive': 0,
                      'domAna': 0,
                      'domReady': 0,
                      'loadpage': 0
                  });
                  return loadpageTimes;
              }
              var result = [];
              var i = 0;
              //遍历存在dom解析时间的计时属性
              try {
                  performance.getEntries().forEach(function (perf) {
                      if (perf.entryType == "navigation") {
                          result.push({
                              'url': perf.name,
                              'entryType': perf.entryType,
                              'type': perf.initiatorType,
                              'navigationStart': perf.navigationStart,
                              'startTime': perf.startTime,
                              'unloadEventStart': perf.unloadEventStart,
                              'unloadEventEnd': perf.unloadEventEnd,
                              'domainLookupStart': perf.domainLookupStart,
                              'domainLookupEnd': perf.domainLookupEnd,
                              'connectStart': perf.connectStart,
                              'connectEnd': perf.connectEnd,
                              'secureConnectionStart': perf.secureConnectionStart,
                              'requestStart': perf.requestStart,
                              'responseStart': perf.responseStart,
                              'responseEnd': perf.responseEnd,
                              'domLoading': perf.domLoading,
                              'domInteractive': perf.domInteractive,
                              'domContentLoadedEventStart': perf.domContentLoadedEventStart,
                              'domContentLoadedEventEnd': perf.domContentLoadedEventEnd,
                              'domComplete': perf.domComplete
                          });

                      }
                  });

                  var arraynum = result.length;
                  var lookupDomain = 0;
                  var connect = 0;
                  var request = 0;
                  var receive = 0;
                  var domAna = 0;
                  var domReady = 0;
                  var loadpage = 0;
                  for (var i = 0; i < arraynum; i++) {
                      //DNS解析时间
                      if (typeof (result[i].domainLookupEnd) == "undefined") {
                          result[i].domainLookupEnd = 0;
                      }
                      if (typeof (result[i].domainLookupStart) == "undefined") {
                          result[i].domainLookupStart = 0;
                      }
                      lookupDomain += result[i].domainLookupEnd - result[i].domainLookupStart;

                      //建立连接时间
                      if (typeof (result[i].connectEnd) == "undefined") {
                          result[i].connectEnd = 0;
                      }
                      if (typeof (result[i].connectStart) == "undefined") {
                          result[i].connectStart = 0;
                      }
                      connect += result[i].connectEnd - result[i].connectStart;

                      //请求数据时间
                      if (typeof (result[i].responseStart) == "undefined") {
                          result[i].responseStart = 0;
                      }
                      if (typeof (result[i].requestStart) == "undefined") {
                          result[i].requestStart = 0
                      }
                      request += result[i].responseStart - result[i].requestStart;

                      //接收数据时间
                      if (typeof (result[i].responseEnd) == "undefined") {
                          result[i].responseEnd = 0;
                      }
                      if (typeof (result[i].responseStart) == "undefined") {
                          result[i].responseStart = 0
                      }
                      receive += result[i].responseEnd - result[i].responseStart;

                      //dom解析时间
                      if (typeof (result[i].domInteractive) == "undefined") {
                          result[i].domInteractive = 0;
                      }
                      if (typeof (result[i].domLoading) == "undefined") {
                          result[i].domLoading = 0;
                      }
                      domAna += result[i].domInteractive - result[i].domLoading;

                      //dom加载时间
                      if (typeof (result[i].domComplete) == "undefined") {
                          result[i].domComplete = 0;
                      }
                      if (typeof (result[i].domContentLoadedEventStart) == "undefined") {
                          result[i].domContentLoadedEventStart = 0;
                      }

                      domReady += result[i].domComplete - result[i].domContentLoadedEventStart;

                  }
                  //dns解析平均时间
                  lookupDomain = lookupDomain / arraynum;
                  //建立连接平均时间
                  connect = connect / arraynum;
                  //请求平均时间
                  request = request / arraynum;
                  //接收数据平均时间
                  receive = receive / arraynum;
                  //dom解析平均时间
                  domAna = domAna / arraynum;
                  //dom加载平均时间
                  domReady = domReady / arraynum;
                  //加载时间
                  loadpage = lookupDomain + connect + request + receive + domAna + domReady;
                  loadpageTimes.push({
                      'lookupDomain': lookupDomain.toFixed(2),
                      'connect': connect.toFixed(2),
                      'request': request.toFixed(2),
                      'receive': receive.toFixed(2),
                      'domAna': domAna.toFixed(2),
                      'domReady': domReady.toFixed(2),
                      'loadpage': loadpage.toFixed(2)
                  });
                  return loadpageTimes;
              } catch (error) {
                  loadpageTimes.push({
                      'lookupDomain': 0,
                      'connect': 0,
                      'request': 0,
                      'receive': 0,
                      'domAna': 0,
                      'domReady': 0,
                      'loadpage': 0
                  });
                  return loadpageTimes;
              }

          }
      }
  } catch (e) { }
}

export {
  loadUam
}


// WEBPACK FOOTER //
// ./src/utils/pagelog.js